<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="reportAddRowDialogTitle"
    class="text-s2 mb-9 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Row</div
  >

  <div
    data-cy="reportAddRowDialogMetricCheckbox"
    class="flex h-9 w-[150px] cursor-pointer flex-row items-center"
    (click)="metricOnClick()"
  >
    <div
      class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
      [ngClass]="{
        'bg-m600': rowType === rowTypeEnum.Metric
      }"
    >
      <m-check-icon *ngIf="rowType === rowTypeEnum.Metric"></m-check-icon>
    </div>

    <div class="ml-5 text-base">Metric</div>
  </div>

  <div
    data-cy="reportAddRowDialogFormulaCheckbox"
    class="mt-3 flex h-9 w-[150px] cursor-pointer flex-row items-center"
    (click)="formulaOnClick()"
  >
    <div
      class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
      [ngClass]="{
        'bg-m600': rowType === rowTypeEnum.Formula
      }"
    >
      <m-check-icon *ngIf="rowType === rowTypeEnum.Formula"></m-check-icon>
    </div>

    <div class="ml-5 text-base">Formula</div>
  </div>

  <div
    data-cy="reportAddRowDialogHeaderCheckbox"
    class="mt-3 flex h-9 w-[150px] cursor-pointer flex-row items-center"
    (click)="headerOnClick()"
  >
    <div
      class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
      [ngClass]="{
        'bg-m600': rowType === rowTypeEnum.Header
      }"
    >
      <m-check-icon *ngIf="rowType === rowTypeEnum.Header"></m-check-icon>
    </div>

    <div class="ml-5 text-base">Header</div>
  </div>

  <div
    data-cy="reportAddRowDialogEmptyCheckbox"
    class="mt-3 flex h-9 w-[150px] cursor-pointer flex-row items-center"
    (click)="emptyOnClick()"
  >
    <div
      class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
      [ngClass]="{
        'bg-m600': rowType === rowTypeEnum.Empty
      }"
    >
      <m-check-icon *ngIf="rowType === rowTypeEnum.Empty"></m-check-icon>
    </div>

    <div class="ml-5 text-base">Empty</div>
  </div>

  <div class="mt-9 flex h-[150px] flex-col justify-start">
    <div
      *ngIf="rowType === rowTypeEnum.Metric"
      class="flex h-11 min-w-[2px] max-w-[1000px] flex-row items-center space-x-5"
    >
      <div
        class="text-s1 flex flex-shrink-0 select-none items-center font-semibold"
        >Metric</div
      >

      <ng-select
        #newMetricSelect
        [fixNgSelectBottom]="newMetricSelect"
        data-cy="newMetricSelect"
        class="new-metric-select w-full min-w-[2px] text-base"
        [items]="metrics"
        [clearable]="false"
        [searchable]="true"
        [searchFn]="newMetricSearchFn"
        [(ngModel)]="newMetricId"
        (change)="newMetricChange()"
        (keyup.esc)="$event.stopImmediatePropagation(); newMetricSelect.blur()"
        (keyup.enter)="
          $event.stopImmediatePropagation(); newMetricSelect.blur()
        "
        appendTo="body"
        placeholder="Select Metric"
        bindLabel="label"
        bindValue="metricId"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 flex flex-row items-center">
            <m-field-result
              class="h-5 w-5"
              [size]="2"
              [fieldClass]="item.fieldClass"
              [result]="item.fieldResult"
            ></m-field-result>

            <m-metric-field-label
              [metric]="item"
              [isShowTop]="true"
              [isShowTime]="true"
              class="ml-3 flex"
            ></m-metric-field-label>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 flex flex-row items-center">
            <m-field-result
              class="h-5 w-5"
              [size]="2"
              [fieldClass]="item.fieldClass"
              [result]="item.fieldResult"
            ></m-field-result>

            <m-metric-field-label
              [metric]="item"
              [isShowTop]="true"
              [isShowTime]="true"
              class="ml-3 flex"
            ></m-metric-field-label>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div
      *ngIf="[rowTypeEnum.Header, rowTypeEnum.Formula].indexOf(rowType) > -1"
      class="flex h-11 max-w-[600px] flex-row items-center"
    >
      <div
        class="text-s1 flex w-[85px] flex-shrink-0 select-none items-center font-semibold"
        >Name</div
      >

      <div [formGroup]="newNameForm" class="relative flex w-full">
        <input
          autocomplete="off"
          data-cy="newNameInput"
          class="form-input border-s3 focus:border-m600 w-full min-w-[100px] resize-none rounded"
          [ngClass]="{
            'border-r600':
              newNameForm.controls['name'].invalid &&
              newNameForm.controls['name'].touched
          }"
          formControlName="name"
          placeholder=""
        />

        <m-validation
          class="absolute -bottom-[22px] left-0"
          [control]="newNameForm.controls['name']"
        ></m-validation>
      </div>
    </div>

    <div
      *ngIf="rowType === rowTypeEnum.Formula"
      class="mt-5 flex flex-1 flex-row items-start"
    >
      <div
        class="text-s1 mt-3 flex w-[85px] flex-shrink-0 select-none items-center font-semibold"
        >Formula</div
      >

      <div [formGroup]="newFormulaForm" class="relative flex w-full">
        <textarea
          data-cy="newFormulaInput"
          class="form-input border-s3 focus:border-m600 placeholder-s400 h-[95px] w-full resize-none rounded font-mono"
          [ngClass]="{
            'border-r600':
              newFormulaForm.controls['formula'].invalid &&
              newFormulaForm.controls['formula'].touched
          }"
          formControlName="formula"
          placeholder="$A + $B"
        ></textarea>

        <m-validation
          class="absolute -bottom-[22px] left-0"
          [control]="newFormulaForm.controls['formula']"
        ></m-validation>
      </div>
    </div>
  </div>

  <div class="mt-14 flex flex-row items-center">
    <button
      data-cy="reportAddRowDialogSaveButton"
      class="bg-m600 text-m0 w-28 select-none rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="save()"
      >Add</button
    >

    <button
      data-cy="reportAddRowDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>

<div *ngIf="metricsHasAccess$ | async"></div>
